import { useAccount } from '@/api/useAccount';
import { CompanyLogo } from '@/components/company/CompanyLogo';

/**
 * The company's logo and name in the app header (M2-19): every role sees it,
 * because `GET /api/v1/account` is every role's. Falls back to the product
 * name while the account loads or if it cannot be read — the header is never
 * empty, and "MainLine Pro" is a proper noun, not a translated string.
 */
export function CompanyBrand() {
  const account = useAccount();
  const data = account.data;

  if (!data) {
    return <span className="font-semibold text-[var(--color-primary)]">MainLine Pro</span>;
  }

  return (
    <span className="flex min-w-0 items-center gap-2" data-testid="company-brand">
      <CompanyLogo
        path={data.logoPath}
        alt=""
        className="h-8 w-auto max-w-[8rem] object-contain"
        testId="company-brand-logo"
      />
      <span className="truncate font-semibold">{data.name}</span>
    </span>
  );
}
